





















import Vue from "vue";
import { mapGetters, mapMutations } from "vuex";

export default Vue.extend({
  name: "SnackBar",
  components: {},
  computed: {
    ...mapGetters("snackbar", [
      "getVisibility",
      "getIcon",
      "getColor",
      "getMessage",
      "getTimer",
    ]),
    isVisible: {
      get() {
        return this.getVisibility;
      },
      set(val) {
        this.setVisibility(val);
      },
    },
  },
  methods: {
    ...mapMutations("snackbar", ["setVisibility"]),
  },
});
